/* eslint-disable no-debugger */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/self-closing-comp */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-use-before-define */
/* eslint-disable array-callback-return */
/* eslint-disable camelcase */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Switch,
  Route,
  useHistory,
  useLocation, useParams
} from "react-router-dom"; // CHG0073013 Removed Routes 
import IdleTimer from 'react-idle-timer';
import HeaderAndFooter from "./layouts/HeaderAndFooter/HeaderAndFooter";
import "./App.css";
import { useAuthorizationContext } from "./providers/AuthorizationHandler/AuthorizationHandler";
import { usePopupManager } from "./providers/PopupManager/PopupManager";

import {
  MESSAGE_TYPE,
} from "./constants";
import LandingPage from "./pages/LandingPage/index";
import Sample from "./pages/VcBomData/VcBomData";
import BatchTimeBooking from "./pages/BatchTimeBooking/BatchTimeBooking";
import OperativeBatchTimeBooking from "./pages/OperativeBatchTimeBooking/OperativeBatchTimeBooking"
import DailyTimeBooking from "./pages/DailyTimeBooking/DailyTimeBooking";
import DeleteBooking from "./pages/DeleteBooking/DeleteBooking";
import Help from "./pages/Help/Help";
import ReportNoPOPage from "./pages/ReportNoPOPage/ReportNoPOPage";
import ManagerReport from "./pages/ReportNoManagerPage/ReportNoManagerPage";
import DeleteOperative from "./pages/DeleteOperative/DeleteOperative";
import AddOperatives from "./pages/AddOperatives/AddOperatives";
import ProjectReport from "./pages/ReportProjectPage/ReportProjectPage";
import ReportShiftUtilizationPage from "./pages/ReportShiftUtilizationPage/ReportShiftUtilizationPage";
import ReportTMLMOR from "./pages/ReportTMLMORPage/ReportTMLMORPage";
import LinkageSearch from "./pages/LinkageSearch/LinkageSearch";
import LinkageDelete from "./pages/LinkageDelete/LinkageDelete";
import OperativeDailyBooking from "./pages/OperativeDailyBooking/OperativeDailyBooking";
import SPOCBCProjectWiseReport from "./pages/SPOCBCProjectWiseReport/SPOCBCProjectWiseReport";
import ViewBookingsDatewise from "./pages/ViewBookingsDatewise/ViewBookingsDatewisePage";
import LinkageAccess from "./pages/LinkageAccess/LinkageAccess";
import {
  UnallocatedOperatorReport,
  UnBookedHrsReport,
  SPOCReport,
} from "./pages";
import Calendar from "./pages/Calendar/Calendar";
import ProjectMasterRpt from "./pages/ProjectMaster/ProjectMasterRpt";
import AuditLogsRpt from "./pages/AuditLogsRpt/AuditLogsRpt";
import BookingEfficiencyReport from "./pages/BookingEfficiencyReport/BookingEfficiencyReport";
import EmployeeWiseBookingDetails from "./pages/EmployeeWiseBookingDetails/EmployeeWiseBookingDetails";
import IndirectProjectReport from "./pages/IndirectProjectReport/IndirectProjectReport";
import PendingBookingApprovalReport from "./pages/PendingBookingApprovalReport/PendingBookingApprovalReport";
import WelcomeCard from "./pages/WelcomeCard/WelcomeCard";
import ApproveRejectBooking from "./pages/ApproveRejectBooking/ApproveRejectBooking";
import RequestorDashboard from "./pages/RequestorDashboard/RequestorDashboard";
import LinkageDashboard from "./pages/LinkageDashboard/LinkageDashboard";
import RequestView from "./pages/AccessControl/RequestView";
import AdditionalAccess from "./pages/AccessControl/AdditionalAccess";
import AccessControl from "./pages/AccessControl/AccessControl";
import BookingStatus from "./pages/BookingStatus/BookingStatus";
import ManagerMapping from "./pages/ManagerMapping/ManagerMapping";
import BulkSpocForm from "./pages/BulkSpoc/BulkSpocForm";
import SystemLockMsg from "./pages/SystemLock/SystemLockPage";
import SystemMaintenanceMsg from "./pages/SystemLock/SystemMaintenancePage";
import BookingDetailsIndividual from "./pages/OperativeTimeBookingSheet/OperativeTimeBookingSheet";
import BookingDetailsOperative from "./pages/BookingDetailsOperative/BookingDetailsOperative";
import LeftNav from "./LeftNav";
import AdditionalAccessPrivilage from "./pages/AccessControlPrivilage/AccessControlPrivilage";
import AccessControlDelete from "./pages/AccessControlDelete/AccessControlDelete";
import { setLogin } from "./redux/features/auth/actions";
import { login } from "./redux/actions/loginActions";
import TimeBookingReview from "./pages/TimeBookingReview/TimeBookingReview";
import SAPDataTransfer from "./pages/SapDataTransfer/SapDataTransfer";
import SupOpReport from "./pages/SUPOPReport/SupOpReport";
import BCMaster from "./pages/BCMaster/BCMaster";
import VehicalPMaster from "./pages/VehicalPMaster/VehicalPMaster";
import AnnouncementUpload from "./pages/AnnouncementUpload/AnnouncementUpload";
import WarningModal from "./components/WarningModal/WarningModal";
import SAPDataReUpload from "./pages/SAPDataReUpload/SAPDataReUpload";
import UnauthorizedUser from "./layouts/UnauthorizedUser";
import Cvloader from "./components/CvLoader/Cvloader";
import useRefreshToken from './hooks/useRefreshToken'
import { azureLoginPage, azureLogout, handleLogout } from "./utils/utils";
import SessionTimeoutModal from "./components/sessionTimeOut/SessionTimeoutModal";
import BudgetExceededProjectMaster from "./pages/BudgetExceededProjectMaster/BudgetExceededProjectMaster";
import BudgetExceededProject from "./components/BudgetExceededReport/BudgetExceededReport";
import apiService from "./apis/apiService";
import ProjectLinkageNotificationReport from "./components/ProjectLinkageNotificationReport/ProjectLinkageNotificationReport";


const MENU = [
  { url: '/manual-sap-tranfer', label: 'Manual SAP Posting', component: SAPDataReUpload },
  { url: '/tml-spoc-bc-project-wise-report', label: 'Project Booking', component: SPOCBCProjectWiseReport },
  { url: '/indirect-project-report', label: 'In-direct Project Booking', component: IndirectProjectReport },
  { url: '/help', label: 'Help', component: Help },
  { url: '/unbooked-hrs-report', label: 'Un-Booked Hrs', component: UnBookedHrsReport },
  { url: '/BCMaster', label: 'BCMaster', component: BCMaster },
  { url: '/VehicalPMaster', label: 'VehicalPMaster', component: VehicalPMaster },
  { url: '/pending-booking-approval-report', label: 'Un-Reviewed Hrs', component: PendingBookingApprovalReport },
  { url: '/time-booking-review', label: 'Time Booking Review', component: TimeBookingReview },
  { url: '/spoc-report', label: 'SPOC Report', component: SPOCReport },
  { url: '/project_master', label: 'Project Master Report', component: ProjectMasterRpt },
  { url: '/audit-logs-report', label: 'Audit Logs Report', component: AuditLogsRpt },
  { url: '/SupOp-Report', label: 'Supervisor-Operative Report', component: SupOpReport },
  { url: '/SAP-data-transfer', label: 'SAP Data Transfer Report', component: SAPDataTransfer },
  { url: '/home', label: 'Home', component: LandingPage },
  { url: '/linkage-dashboard', label: 'Linkage Dashboard', component: LinkageDashboard },
  { url: '/requestor-dashboard', label: 'Request Dashboard', component: RequestorDashboard },
  { url: '/erc-calendar', label: 'Report', component: Sample },
  { url: '/report-po-linckage', label: 'Report PO', component: OperativeDailyBooking },
  { url: '/report-no-po-linkage', label: 'No Linkage Report', component: ReportNoPOPage },
  { url: '/erc-delete-operative', label: 'Delete Operative', component: DeleteOperative },
  { url: '/erc-daily-time-booking', label: 'Daily Timebooking', component: DailyTimeBooking },
  { url: '/unallocated-operator-report', label: 'Un-Allocated OP', component: UnallocatedOperatorReport },
  { url: '/additional-access', label: 'Additional Access', component: AdditionalAccess },
  { url: '/booking-details-individual', label: 'Booking Details - Individual', component: BookingDetailsIndividual },
  { url: '/employee-wise-bookingDetails', label: 'Employee Wise BookingDetails', component: EmployeeWiseBookingDetails },
  { url: '/tml-operative-daily-booking', label: 'Operative Daily Booking', component: OperativeDailyBooking },
  { url: '/ApproveRejectBooking', label: 'ApproveRejectBooking', component: ApproveRejectBooking },
  { url: '/report-manager', label: 'No Manager Report', component: ManagerReport },
  { url: '/erc-batch-time-booking', label: 'Register Time - Individual', component: BatchTimeBooking },
  { url: '/erc-op-batch-time-booking', label: 'Register Time - Operative', component: OperativeBatchTimeBooking },
  { url: '/erc-delete-booking', label: 'Delete Booking', component: DeleteBooking },
  { url: '/erc-add-operative', label: 'Add/ delete Operatives', component: AddOperatives },
  { url: '/project-report', label: 'Project Report', component: ProjectReport },
  { url: '/linkage-access', label: 'Linkage Access', component: LinkageAccess },
  { url: '/manager-mapping', label: 'Manager Mapping', component: ManagerMapping },
  { url: '/shift-report', label: 'Shift Utilization Report', component: ReportShiftUtilizationPage },
  { url: '/tml-mor-report', label: 'TML EOR Report', component: ReportTMLMOR },
  { url: '/tml-linkage-search', label: 'Linkage Search', component: LinkageSearch },
  { url: '/tml-linkage-search', label: 'Linkage Search / Delete', component: LinkageSearch },
  { url: '/tml-linkage-delete', label: 'Linkage Delete', component: LinkageDelete },
  { url: '/view-booking', label: 'View Booking Datewise', component: ViewBookingsDatewise },
  { url: '/home-calendar', label: 'Calendar', component: Calendar },
  { url: '/welcome-card', label: 'WelcomeCard', component: WelcomeCard },
  { url: '/request-view/:requestType/:activeId', label: 'Request View', component: RequestView },
  { url: '/access-control/:requestType/:activeId', label: 'Access Control', component: AccessControl },
  { url: '/access-control/:parameter', label: 'Additional Project Linkage', component: AccessControl },
  { url: '/booking-status', label: 'Booking Status', component: BookingStatus },
  { url: '/booking-details-operative', label: 'Booking Details - Operative', component: BookingDetailsOperative },
  { url: '/announcement-help', label: 'AnnouncementUpload', component: AnnouncementUpload },
  { url: '/booking-efficiency-report', label: 'Booking Efficiency Report', component: BookingEfficiencyReport },
  { url: '/access-control-privilage', label: 'Access and role control', component: AdditionalAccessPrivilage },
  { url: '/access-control-delete', label: 'Delete Access And Role', component: AccessControlDelete },
  { url: '/bulk-spoc-uploaddel/:parameter', label: 'Bulk Linkage / De-linkage', component: BulkSpocForm },
  { url: '/budget-exceeded-project-master', label: 'Budget Exceeded Project', component: BudgetExceededProjectMaster },
  { url: '/booking-on-budget-exceeded-project', label: 'Booking on -Budget Exceeded Project', component: BudgetExceededProject },
  { url: '/Project-linkge-notification-report', label: 'Project Linkage Notification Report', component: ProjectLinkageNotificationReport},
]


function App() {
  useRefreshToken()
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { logoutUser } = useAuthorizationContext();
  const [openCloseFlag, setOpenClose] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 500);
  const [path, setPath] = useState("");
  const [isAppLock, setIsAppLock] = useState(false);
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [showSessionExpired, setShowSessionExpired] = useState(false);
  const alldatas = sessionStorage.getItem("123342w188")
  let decoded = "test"
  let newData
  if (alldatas) {
    decoded = atob(`${alldatas}`);
    newData = JSON.parse(decoded)
  }

  const { showPopup } = usePopupManager();
  const userDetails = newData;
  const [isWarningOpen, setIsWarningOpen] = React.useState(false);

  useEffect(() => {
    if (location.pathname == "/") {
      setPath("/home");
      dispatch(setLogin(userDetails))
    } else {
      setPath(location.pathname);
      dispatch(setLogin(userDetails))
    }
  }, [location]);



  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth <= 500);
  }

  const setOpenCloseAction = () => {
    setOpenClose(!openCloseFlag);
  };
  const [urlState, setUrlState] = useState(true);
  const [valideRoute, setValideRoute] = useState([]);
  const [loading, setLoading] = useState(false)
  const [loginDone, setLoginDone] = useState(false);
  const auth = useSelector((state) => state.auth);
  let menuListCount = 0;
  if (auth?.menuList !== undefined) {
    menuListCount = auth?.menuList.length;
  }
  const status = auth?.recentStatus
  const [isRouting, setIsRouting] = useState(false)
  const [isAuthorized, setIsAuthorized] = useState(false)
  const handleLogout = () => {
    sessionStorage.clear();
    dispatch(logoutUser);
     window.location.href = `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}/oauth2/v2.0/logout`
    
};

  const handleLogin = async () => {
    setLoading(true);
    try {
      const response = await apiService.handleUserInfoLogin({}, dispatch)
      if (response.status === 401) {
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: 'Please enter valid credentials',
        });
        setTimeout(()=>{
          handleLogout()
        },15000)
        return;  // exit early
      }
      const responseJson = response;
      if (responseJson.msg === 'You Are Not An Authoried User...!' || responseJson.status === 403) {
        setIsAuthorized(true);
        setLoading(false)
        setLoginDone(true)
        history.push('/unauthorized');
        return;
      }
      if (responseJson.msg === 'Application is under maintenance.') {
        setIsAuthorized(true);
        setLoading(false)
        setLoginDone(true)
        history.push('/SystemMaintenance');
        return;
      }
      if (responseJson.msg === 'Application is locked for this time period.') {
        setIsAuthorized(true);
        setLoading(false)
        setLoginDone(true)
        history.push('/SystemLock');
        return;
      }

      if (responseJson.detail === 'Invalid credentials') {
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: 'Please enter valid credentials',
        });
        return;
      }

      if (responseJson.msg === 'Unable to connect to server') {
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: 'Unable to connect to the server',
        });
        return;
      }

      if (responseJson.msg === 'Fail' && responseJson.data === 'Invalid User') {
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: 'Invalid User',
        });
        return;
      }

      if (responseJson.data === 'User Already Logged In On Another Browser Or Screen' && responseJson.msg === 'Fail') {
        showPopup({
          type: MESSAGE_TYPE.WARNING,
          contextText: MESSAGE_TYPE.WARNING,
          info: 'User already logged in on another browser or screen.',
        });
        return;
      }

      // success logic
      const empDet = responseJson.data.emp_dets[0];
      const userRoleList = empDet.user_role?.split(',');
      const userInfo = {
        userName: empDet.employee_name,
        personNumber: empDet.person_no,
        personArea: empDet.pers_area,
        personSubArea: empDet.pers_subarea,
        companyCode: empDet.company_code,
        bookingStatus: empDet.booking_status,
        costCenter: empDet.cost_center,
        userRole: userRoleList,
        persArea: empDet.pers_area,
        workArea: empDet.work_area,
        businessArea: empDet.business_area,
        ip_address: responseJson.data.ip_address,
        isAuthenticated: true,
        location: empDet.location,
        recentStatus: response.status,
      };
      dispatch(login(userInfo));
      dispatch(setLogin(userInfo));
      setIsRouting(true);
      setIsAuthorized(false);
      setLoginDone(true);
      if(!sessionStorage.getItem('isAuthenticated')){
        history.push('/home');
      }
      if (window.location.pathname === '/home') {
        history.push('/home');
      } else {
        history.push(window.location.pathname);
      }
    } catch (error) {
      dispatch(setLogin({recentStatus: error.response.status}))
      setIsAuthorized(true);
      setLoading(false);

      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (status === 403) {
      setIsWarningOpen(true)
      setIsAuthorized(true)
      history.push('/unauthorized');
    }
    else if(status === 401){
      setIsWarningOpen(true)
      setIsAuthorized(true)
      history.push('/unauthorized');
    }
     else if (status === 423) {
      setIsAppLock(true)
      if (location.pathname !== "/SystemLock") {
        history.replace("/SystemLock")
      }
    } else if (status === 503) {
      setIsMaintenance(true)
      if (location.pathname !== "/SystemMaintenance") {
        history.replace("/SystemMaintenance")
      }
    } else if (status === 440) {
      setShowSessionExpired(true);
      setIsAuthorized(true);
      setLoading(false)
      setLoginDone(true)
    } else if (status === 429) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: 'To many request please wait for some time!',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.recentStatus]);

  useEffect(() => {
    const initLogin = async () => {
      if (auth.loginStatus === 'ALREADY_LOGGED_IN' || auth.loginStatus === 'SUCCESS' || sessionStorage.getItem('isAuthenticated')) {
        await handleLogin();
      }
    };
    initLogin();
  }, []);
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, [isMobile]);

  const getUrlFromWindow = window.location.pathname;
  const userPage = () => {
    if (auth?.userRole?.length >= 1) {
      let allPath = []
      if (auth?.menuList !== undefined) {
        auth?.menuList.map((item) => {
          const path = MENU.filter((menu) => menu.label === item.label);
          allPath = [...allPath, ...path];
        })

      }

      const reviewUrl = ['/request-view/', '/access-control', '/bulk-spoc-uploaddel', '/SystemLock', '/SystemMaintenance'];

      const exsistURL = reviewUrl.some(url => getUrlFromWindow.includes(url));
      const urlData = allPath.filter((item, index) => {

        const getUrl = allPath.some(item => item.url === getUrlFromWindow);
        setUrlState(exsistURL ? true : getUrl);
      });

      const unique = allPath.filter((obj, index) => {
        return index === allPath.findIndex(o => obj.label === o.label);
      });
      setValideRoute(unique)

    }
  };
  useEffect(() => {
    userPage();
  }, [auth.userRole, menuListCount]);

  useEffect(() => {
    // Start# Role 'B' User not authorized to access this pages
    const linkageUrl = ['/access-control/APL', '/linkage-dashboard'];
    const isExactMatch = linkageUrl.includes(getUrlFromWindow);

    const isExactMatchRole = (userRole) => userRole.length === 1 && userRole.includes("B");

    if (isExactMatchRole(auth.userRole) && isExactMatch) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "You are not authorized to access this page.",
        // reloads: true,
      });
      history.push("/home");
    } // End#
    else if (!urlState) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "You are not authorized to access this page.",
        // reloads: true,
      });
      history.push("/home");
    }
  }, [auth.userRole, getUrlFromWindow]);

  const idleTimerRef = useRef(null);
  const onIdle = () => {
    // logout()
    sessionStorage.clear()
    handleLogout();
    azureLogout();

  };

  useEffect(() => {
    return history.listen(() => {
      if (location.pathname !== "/SystemLock" && isAppLock) {
        history.push("/SystemLock");
      } else if (location.pathname !== "/SystemMaintenance" && isMaintenance) {
        history.push("/SystemMaintenance");
      } else if (history.action === "POP" && !isAppLock) {
        history.replace("/home");
      }
    });
  }, [history]);

  let paramsflag = false
  if (window.location.pathname === '/') {
    paramsflag = false

  } else {
    paramsflag = false
  }

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '20%' }}>
        <Cvloader />
      </div>
    );
  }
  return (
    <div className="App">
      {auth.userRole !== "" && paramsflag == false && isAppLock == false && isMaintenance == false && (
        <LeftNav
          displayDrawer={isMobile ? "mobile" : "desktop"}
          devices={isMobile}
          openClose={openCloseFlag}
        />
      )}
      <Switch>
        {
          isAuthorized && <Route exact path="/home" component={LandingPage} />
        }
        {
          isAuthorized && (<Route exact path='/unauthorized' component={UnauthorizedUser}></Route>)
        }
        {isRouting && isAuthorized && (
          <Route exact path="/home" component={() => (
            <HeaderAndFooter
              displayDrawer={isMobile ? "mobile" : "desktop"}
              openClose={setOpenCloseAction}
            >
              <LandingPage />
            </HeaderAndFooter>
          )} />
        )}

        {isAppLock ? (
          <Route exact path="/SystemLock" component={SystemLockMsg} />
        ) : isMaintenance ? (
          <Route exact path="/SystemMaintenance" component={SystemMaintenanceMsg} />
        ) : (
          <HeaderAndFooter
            displayDrawer={isMobile ? "mobile" : "desktop"}
            openClose={setOpenCloseAction}
          >
            {valideRoute.map(({ component, url }) => (
              <Route key={url} exact path={url} component={component} />
            ))}
            {/* <Route exact path="/home" component={LandingPage} /> */}

            <WarningModal
              concurrentCross="true"
              open={isWarningOpen}
              // rowsData={selectedRows}
              handleClose={() => setIsWarningOpen(false)}
              confirmDelete={() => {
                logoutUser(dispatch)
                localStorage.clear();
                sessionStorage.clear()
              }}
              // msg="Session has expired, Redirecting to login page"
              msg={[
                "Since you are logged in through another session",
                "the current session has been logged out!!",
                "Thank You!"
              ].join('<br />')}
              popUpHeading="&nbsp;Login"
            />
            {paramsflag == false &&
              <>
                <IdleTimer ref={idleTimerRef} timeout={600000} onIdle={onIdle}></IdleTimer>              
                <SessionTimeoutModal
                  show={showSessionExpired}
                  onLogin={() => {
                    setShowSessionExpired(false);
                    azureLoginPage()
                  }}

                />

              </>

            }

          </HeaderAndFooter>
        )
        }
      </Switch>
    </div>
  );
}
export default App;